export const projectFilters = () => {
  $('.project-filters .wp-block-button__link').click(function (e) {
    e.preventDefault();
    const pfilter = $(this).attr('href');
    const ptarget = pfilter.substring(1, pfilter.length);
    console.log(ptarget);

    $('.filtered').removeClass('filtered');
    $('.is-active').removeClass('is-active');

    $(this).addClass('is-active');

    $(this).closest('.pattern-featured-projects').addClass('has-filters');

    $('[data-filter=' + ptarget + ']').each(function () {
      $(this).closest('li').addClass('filtered');
    });
  });

  $('.project-filters .wp-block-button:first-child .wp-block-button__link')
    .addClass('is-active')
    .trigger('click')
    .trigger('click');
};
